import { EmptyDescription } from "@aircall/ds";

import { Section, SectionHeader, SectionTitle } from "@/blocks/Section/Section";

import { KeysList } from "@/components/SectionKeyTopics/KeysList";

import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout/PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout/PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle/PlaygroundSubSectionTitle";

const MOCK_KEY_TOPICS = [
  "hubspot integration",
  "pricing & budget",
  "an exceptionally long key topic that overflows",
];

function WithTopics() {
  return (
    <Section data-test="key-topics-section">
      <SectionHeader>
        <SectionTitle>Key topics</SectionTitle>
      </SectionHeader>
      <KeysList keys={MOCK_KEY_TOPICS} />
    </Section>
  );
}

function EmptyState() {
  return (
    <Section data-test="key-topics-section">
      <SectionHeader>
        <SectionTitle>Key topics</SectionTitle>
      </SectionHeader>
      <EmptyDescription
        className="font-normal"
        data-test="no-key-topics-generated"
      >
        No key topics generated
      </EmptyDescription>
    </Section>
  );
}

export function PlaygroundSectionKeyTopics() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>With topics</PlaygroundSubSectionTitle>
        <WithTopics />
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Empty state</PlaygroundSubSectionTitle>
        <EmptyState />
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
